import { Injectable } from '@angular/core'
import { CreateNewsDto, FindNewsQueryParamsDto, NewsDto, UpdateNewsDto } from '@api/dto/news'
import { PageResultDto } from '../dto'
import { HttpService } from './http.service'
import { ADMIN_API_ENDPOINTS } from "../common/api-endpoints"
@Injectable()
export class AdminNewsService {
  constructor(
    private httpService: HttpService
    ) {
  }

  async find(findNewsDto: FindNewsQueryParamsDto) {
    return await this.httpService.get<PageResultDto<NewsDto>>(ADMIN_API_ENDPOINTS.NEWS, findNewsDto)
  }

  async create(createNewsDto: CreateNewsDto) {
    return await this.httpService.post<NewsDto>(ADMIN_API_ENDPOINTS.NEWS, createNewsDto)
  }

  async findOne(id: string) {
    return await this.httpService.get<NewsDto>(`${ADMIN_API_ENDPOINTS.NEWS}/${id}`)
  }

  async update(id: string, updateNewsDto: UpdateNewsDto) {
    return await this.httpService.put<Boolean>(`${ADMIN_API_ENDPOINTS.NEWS}/${id}`, updateNewsDto)
  }

  async delete(id: string) {
    return await this.httpService.delete<Boolean>(`${ADMIN_API_ENDPOINTS.NEWS}/${id}`)
  }

  async toggleStatus(id: string, enabled: boolean) {
    return await this.httpService.patch<Boolean>(`${ADMIN_API_ENDPOINTS.NEWS}/${id}/toggle`, { enabled })
  }
}
